// 获取质检规则配置
export const qualityRuleSettingGet = params => {
  return window._this.$http.get(
    `/erp/AdminSetting/qualityRuleSettingGet`,
    params,
  );
};
// 保存质检规则
export const qualityRuleSettingSave = params => {
  return window._this.$http.post(
    `/erp/AdminSetting/qualityRuleSettingSave`,
    params,
  );
};
// 履约信息-板块列表
export const getSupplyFulfillColumnList = params =>
  window._this.$http.get("/erp/CustomPerform/getInfoList", {
    params,
  });
// 履约信息-板块新增
export const saveSupplyFulfillColumn = params =>
  window._this.$http.post("/erp/CustomPerform/saveInfo", params);
// 履约信息-板块详情
export const getSupplyFulfillColumnInfo = params =>
  window._this.$http.get("/erp/CustomPerform/getInfo", {
    params,
  });

// 履约信息-字段列表
export const getSupplyColumnFieldList = params =>
  window._this.$http.get("/erp/CustomPerform/getFieldlist", {
    params,
  });
// 履约信息-字段详情
export const getSupplyColumnFieldInfo = params =>
  window._this.$http.get("/erp/CustomPerform/getField", {
    params,
  });
// 履约信息-字段保存
export const saveSupplyColumnField = params =>
  window._this.$http.post("/erp/CustomPerform/saveField", params);

// 走访信息-字段列表
export const getSupplyVisitFieldList = params =>
  window._this.$http.get("/erp/CustomPerform/getVisitFieldlist", {
    params,
  });
// 走访信息-字段保存
export const saveSupplyVisitField = params =>
  window._this.$http.post("/erp/CustomPerform/saveVisitField", params);
// 走访信息-配置信息
export const getSupplyVisitFieldOptions = params =>
  window._this.$http.post("/erp/CustomPerform/visitFieldOptions", { params });
// 走访信息-字段状态切换
export const exchangeSupplyVisitFieldStatus = params =>
  window._this.$http.post("/erp/CustomPerform/switchVisitStatus", params);

// 系统配置-操作原因-查询列表
export const getSystemFieldOperationReason = params => {
  return window._this.$http.get(`/modi/system_field/operation_reason`, {
    params,
  });
};

// 系统配置-操作原因-查询编辑详情
export const getSystemFieldOperationReasonDetail = params => {
  return window._this.$http.get(`/modi/system_field/operation_reason_detail`, {
    params,
  });
};
// 系统配置-操作原因-查询
export const getSystemFieldOperationReasonDetailVisit = params => {
  return window._this.$http.get(
    `/modi/system_field/operation_reason_detail_visit`,
    {
      params,
    },
  );
};

// 系统配置-操作原因-新增
export const systemFieldOperationReasonAdd = params => {
  return window._this.$http.post(
    `/modi/system_field/operation_reason_detail`,
    params,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
// 系统配置-操作原因-更新
export const systemFieldOperationReasonUpdate = params => {
  return window._this.$http.put(
    `/modi/system_field/operation_reason_detail`,
    params,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

// 系统配置-操作原因-日志
export const getSystemFieldOperationReasonLog = params => {
  return window._this.$http.get(`/modi/system_field/operation_reason_log`, {
    params,
  });
};



// WEBPACK FOOTER //
// ./src/api/setting.js